import WarpElement from "@warp-ds/elements-core";
import "@warp-ds/elements/components/card";
import { css, html } from "lit";

import { CollectionWithLink } from "../../models/collection.js";
import { largeNumberFormatter } from "../../utils/formatters.js";
import { trackClickEvent } from "../tracking.js";
import { getLocaleByBrand } from "../../utils/getLocaleByBrand.js";
import { Brand } from "../../constants.js";

class CollectionCard extends WarpElement {
    declare collections: CollectionWithLink[];
    declare header: string;
    declare brand: Brand;

    static properties = {
        collections: { type: Array },
        header: { type: String },
        brand: { type: String },
    };

    static styles = [
        WarpElement.styles,
        css`
            .z-collection-overlay {
                z-index: 12;
            }
            @css-placeholder-6JTEL4;
        `,
    ];

    constructor() {
        super();
    }

    async connectedCallback() {
        super.connectedCallback();
    }

    render() {
        return html`<div class="min-h-[230] max-w-full isolate">
            <h3 class="t3 mb-0">${this.header}</h3>
            <div class="-mx-16 md:-mx-10">
                <div
                    class="grid grid-flow-col auto-cols-[minmax(144px,1fr)] overflow-x-auto gap-16 p-16 -mb-16 md:px-10"
                    style="scrollbar-width: none;"
                >
                    ${this.collections.map((collection: CollectionWithLink) => {
                        return html`<w-card
                            class="focus-within:outline outline-4 overflow-hidden s-outline-focused rounded-8 max-h-[186] s-border border transition-transform hover:scale-102 focus-within:scale-102 hover:shadow-s focus-within:shadow-s"
                            style="background-color: var(--w-s-color-border)"
                            @click="${() => trackClickEvent(collection.trackingEvent)}"
                        >
                            <a
                                class="aspect-144/186 card-overlay flex flex-col relative z-collection-overlay"
                                href="${collection.link}"
                                aria-label="Collection of ${collection.title}. Total number of ads is ${collection.hits}"
                            >
                                <div class="flex flex-col justify-end p-16 s-text-inverted gap-4">
                                    <label class="cursor-pointer font-bold">${collection.title}</label>
                                    <span>${largeNumberFormatter(collection.hits, getLocaleByBrand(this.brand))}</span>
                                </div>
                            </a>
                            <div
                                class="absolute bottom-0 right-0 left-0 z-10 bg-cover h-full bg-center"
                                style="background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.95) 0%, rgba(0, 0, 0, 0.77) 15.63%, rgba(95, 95, 95, 0.49) 34.89%, rgba(196, 196, 196, 0.00) 50%), url('${collection.imageUrl}')"
                            ></div>
                        </w-card>`;
                    })}
                </div>
            </div>
        </div>`;
    }
}

customElements.define("mfp-collection-cards", CollectionCard as unknown as CustomElementConstructor);
